import { render, staticRenderFns } from "./CustomerSatisfactionHistory.vue?vue&type=template&id=f2c378d4&scoped=true&"
import script from "./CustomerSatisfactionHistory.vue?vue&type=script&lang=js&"
export * from "./CustomerSatisfactionHistory.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSatisfactionHistory.vue?vue&type=style&index=0&id=f2c378d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c378d4",
  null
  
)

export default component.exports